import { getTeamLineupsInitialState } from './lineups'

export * from './lineups'

export const getTeamInitialState = () => ({
  lineups: getTeamLineupsInitialState(),
})
